// extracted by mini-css-extract-plugin
export default {"wrapper":"map__wrapper___1WfID","map":"map__map___e6BF0","staticMap":"map__staticMap___2wG7t"};